import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { BookCover } from './BookCover';
import { VOLUMES, VOLUME_INCLUDES } from '../data/content';
export function VolumesSection() {
  return <section id="volumes" className="border-y border-ink-700/60 bg-ink-900 py-10 sm:py-12" style={{
    paddingTop: "0px",
    paddingBottom: "7px"
  }} data-id="element-226" data-mp="cnzdreud6xcy">
      <div className="mx-auto max-w-content px-5" data-id="element-227" data-mp="3g4ybusun4maf">
        <SectionHeading eyebrow="📚 WHAT YOU GET" title="The 6" highlight="Volumes" data-id="element-228" data-mp="3g5r82zvz3teb" />

        <div className="mt-6 grid gap-3 lg:grid-cols-2" data-id="element-229" data-mp="3c4xky8qcuimh">
          {VOLUMES.map(volume => <article key={volume.number} className="flex h-full gap-4 rounded-2xl border border-ink-700 bg-ink-850 p-5 transition-colors duration-150 ease-out hover:border-lime-700/60" style={{
          paddingTop: "15px",
          paddingBottom: "6px"
        }} data-id="element-230" data-mp="3pvarq7rifra8">
              <BookCover src={volume.image} alt={`${volume.title} ebook cover`} className="h-[160px] w-[118px]" data-id="element-231" data-mp="2xcx7xc30e5u5" />

              <div className="flex min-w-0 flex-col" data-id="element-232" data-mp="2sdsw0dop9u04">
                <span className="w-fit rounded-full bg-lime-600/15 px-2.5 py-0.5 text-[10px] font-extrabold uppercase tracking-[0.15em] text-lime-400" data-id="element-233" data-mp="29egxw8p9wpfn">
                  {volume.number}
                </span>

                <h3 className="mt-2 text-base font-extrabold uppercase leading-tight text-white sm:text-lg" data-id="element-234" data-mp="2j5tsv96dbvpw">
                  {volume.title}
                </h3>
                <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-white/40" data-id="element-235" data-mp="1qh60ktn7c62u">
                  {volume.zones}
                </p>
                <p className="mt-2 text-sm leading-snug text-white/65" data-id="element-236" data-mp="1vfzegn6ehz3j">{volume.body}</p>

                <ul className="mt-2.5 space-y-1 border-t border-ink-700 pt-2.5" data-id="element-237" data-mp="20d9689h9imuj">
                  {volume.bullets.map(bullet => <li key={bullet} className="flex items-start gap-2 text-sm text-white/80" style={{
                fontSize: "12px"
              }} data-id="element-238" data-mp="24eb3ikrmcotv">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-lime-400" aria-hidden="true" data-id="element-239" data-mp="3fv1f6jeta8uv" />
                      {bullet}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mt-4 rounded-2xl border border-lime-700/40 bg-ink-850 p-5 text-center" data-id="element-240" data-mp="1bqy7mwcz9ifz">
          <h3 className="text-xs font-extrabold uppercase tracking-[0.18em] text-lime-400" data-id="element-241" data-mp="1pq7oly90cgl0">
            Every volume includes
          </h3>
          <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-6 gap-y-1.5" data-id="element-242" data-mp="1kqlc5r1074d9">
            {VOLUME_INCLUDES.map(item => <li key={item} className="inline-flex items-center gap-2 text-sm font-semibold text-white/80" data-id="element-243" data-mp="t1rwpvifdv4q">
                <CheckIcon className="h-4 w-4 shrink-0 text-lime-400" aria-hidden="true" data-id="element-244" data-mp="16swoycjgrl51" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}